var map = {
	"./3d-space-64.svg": "56f4",
	"./Aitta-delivery.svg": "77eb",
	"./Amex-small.svg": "9506",
	"./Klarna-small.svg": "303e",
	"./LA_logo_merkki_nega.png": "77c8",
	"./LA_logo_vaaka.png": "69af",
	"./LA_logo_vaaka_nega.png": "3952",
	"./Loviisan-Aitta-logo.jpg": "d929",
	"./Loviisan-Aitta-nega-logo.png": "447b",
	"./Mastercard-small.svg": "a268",
	"./Visa-small.svg": "48b3",
	"./about-us/gia-chicago.jpg": "bf3a",
	"./about-us/henkilot.jpg": "0bba",
	"./about-us/paarakennus.jpg": "cfa2",
	"./about-us/valikoima.jpg": "1d39",
	"./bank-logos.svg": "3bba",
	"./bank-logos/aktia-logo.svg": "3b8e",
	"./bank-logos/alands-logo.svg": "386d",
	"./bank-logos/danskebank-logo.svg": "e7c2",
	"./bank-logos/handelsbanken-logo.svg": "ce1d",
	"./bank-logos/nordea-logo.svg": "47cc",
	"./bank-logos/op-logo.svg": "f38f",
	"./bank-logos/pop-logo.svg": "0f60",
	"./bank-logos/s-pankki-logo.svg": "f25f",
	"./bank-logos/saastopankki-logo.svg": "0722",
	"./bank-logos/sp-logo.svg": "b9fe",
	"./bread-bg2.jpg": "a274",
	"./carousel-imgs/DSC_4272.jpg": "6d98",
	"./carousel-imgs/Sisustuslauantai etusivu.jpg": "896b",
	"./carousel-imgs/Slide001.jpg": "03eb",
	"./carousel-imgs/Slide002.jpg": "ce66",
	"./carousel-imgs/Slide003.jpg": "71b7",
	"./carousel-imgs/Slide004.jpg": "c03c",
	"./carousel-imgs/Slide005.jpg": "95b6",
	"./carousel-imgs/Slide006.jpg": "9f11",
	"./carousel-imgs/Slide007.jpg": "7347",
	"./carousel-imgs/etusivu1.jpg": "26f2",
	"./carousel-imgs/etusivu2.jpg": "2d31",
	"./carousel-imgs/etusivu3.jpg": "9826",
	"./carousel-imgs/slide-1.jpg": "22aa",
	"./carousel-imgs/slide-2.jpg": "26f8",
	"./carousel-imgs/slide-3.jpg": "258e",
	"./carousel-imgs/slide-4.jpg": "9887",
	"./contact/Helena.jpg": "9bd1",
	"./credit-card-pay.svg": "ad33",
	"./demo-image.jpg": "e97c",
	"./heart-64.svg": "f630",
	"./inspired/Insp-1-1.jpg": "8109",
	"./inspired/Insp-1-2.jpg": "89e4",
	"./inspired/Insp-1-3.jpg": "46b4",
	"./inspired/Insp-2-1.jpg": "9b92",
	"./inspired/Insp-2-2.jpg": "e9c6",
	"./inspired/Insp-3-1.jpg": "c979",
	"./inspired/Insp-3-2.jpg": "7b36",
	"./inspired/Insp-4-1.jpg": "6ded",
	"./klarna-64.svg": "02d3",
	"./klarna-pay.svg": "723b",
	"./logo-l-nega.svg": "b17e",
	"./logo.png": "9d64",
	"./logo.svg": "e347",
	"./matkahuolto-logo.svg": "6101",
	"./no-img.jpg": "bbb0",
	"./online-bank-pay.svg": "e977",
	"./package-delivery.svg": "2187",
	"./pickup-pay.svg": "48cf",
	"./posti-logo.svg": "42a4",
	"./services/Elina.jpg": "b22e",
	"./services/Ompelimo001.jpg": "d3cd",
	"./services/Ompelimo002.jpg": "983f",
	"./services/Ompelimo003.jpg": "c376",
	"./services/Sisustus001.jpg": "b2e6",
	"./services/Sisustus002.jpg": "ebbe",
	"./services/Sisustus003.jpg": "1988",
	"./services/Taina.jpg": "b1c6",
	"./services/Tapetti001.jpg": "411f",
	"./services/Tapetti002.jpg": "e273",
	"./services/Tapetti003.jpg": "f892",
	"./truck-delivery.svg": "e3b3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";